import service from './axios';

// 获取积分历史
/**
 * 获取积分历史记录
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.pageSize - 每页大小
 * @param {string} params.keyword - 搜索关键词
 * @param {string} params.type - 积分类型（income/expense）
 * @param {string} params.source - 积分来源
 * @returns {Promise}
 */
export const fetchPointsHistory = (params) => {
  return service({
    method: 'get',
    url: '/manage/points/history',
    params
  });
};

// 手动发放积分
export const addPoints = (userId, data) => {
  return service({
    method: 'post',
    url: '/manage/points/manually-issue',
    data: {
      user_id: userId,
      amount: data.points,
      source: data.source,
      reference_id: data.orderNumber,
      description: data.remark
    }
  });
};

// 获取积分设置
/**
 * 获取积分设置
 * @returns {Promise}
 */
export const getPointSettings = () => {
  return service({
    method: 'get',
    url: '/manage/points/settings'
  });
};

// 更新积分设置
/**
 * 更新积分设置
 * @param {Object} data - 积分设置数据
 * @param {number} data.room_fee_point_ratio - 手工录入房费积分比例
 * @param {number} data.system_consumption_point_ratio - 系统消费积分比例
 * @param {number} data.mall_discount_ratio - 积分商城抵扣比例
 * @param {number} data.mall_minimum_points - 积分商城积分使用最低门槛
 * @param {number} data.daily_checkin_points - 每日签到积分
 * @returns {Promise}
 */
export const updatePointSettings = (data) => {
  return service({
    method: 'put',
    url: '/manage/points/settings',
    data
  });
};

// 获取积分设置（新接口）
/**
 * 获取积分设置
 * @returns {Promise}
 */
export const getPointSettingsNew = () => {
  return service({
    method: 'get',
    url: '/manage/point-settings'
  });
};

// 更新积分设置（新接口）
/**
 * 更新积分设置
 * @param {Object} data - 积分设置数据
 * @returns {Promise}
 */
export const updatePointSettingsNew = (data) => {
  return service({
    method: 'put',
    url: '/manage/point-settings',
    data
  });
};

// 用户签到
/**
 * 用户签到
 * @returns {Promise}
 */
export const checkin = () => {
  return service({
    method: 'post',
    url: '/api/front/points/checkin'
  });
};

// 获取签到记录
/**
 * 获取签到记录
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.page_size - 每页大小
 * @returns {Promise}
 */
export const getCheckinHistory = (params) => {
  return service({
    method: 'get',
    url: '/api/front/points/checkin-history',
    params
  });
};

// 检查签到状态
/**
 * 检查签到状态
 * @returns {Promise}
 */
export const getCheckinStatus = () => {
  return service({
    method: 'get',
    url: '/api/front/points/checkin-status'
  });
};